// ./client/src/user/dashboard/UserTopBar.js
import React from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  alpha,
  Stack,
  Breadcrumbs,
  Link,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ThemeToggle from "../../common/ThemeToggle";
import ChangeLang from "../../common/ChangeLang"; // ← ADD THIS

const menuLabels = {
  dashboard: "Dashboard",
  "download-torrent": "Download Torrent",
  "my-files": "My Files",
  "my-plan": "My Plan",
  billing: "Billing & Orders",
  profile: "Profile",
};

const UserTopBar = ({
  theme,
  isMobile,
  isDark,
  selectedMenu,
  toggleColorMode,
  handleDrawerToggle,
}) => {
  const history = useHistory();
  return (
    <>
      {isMobile && (
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            bgcolor: "background.paper",
            borderBottom: `1px solid ${theme.palette.divider}`,
            color: "text.primary",
          }}
        >
          <Toolbar sx={{ gap: 1 }}>
            <IconButton edge="start" onClick={handleDrawerToggle}>
              <MenuIcon />
            </IconButton>
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: 1.5,
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${alpha(theme.palette.primary.main, 0.7)})`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CloudDownloadIcon sx={{ fontSize: 16, color: "#fff" }} />
            </Box>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              sx={{ flexGrow: 1 }}
            >
              TorrentCloud
            </Typography>

            {/* ← ADD ChangeLang here */}
            <ChangeLang />

            <ThemeToggle
              isDark={isDark}
              toggleColorMode={toggleColorMode}
              theme={theme}
              size="small"
            />
          </Toolbar>
        </AppBar>
      )}

      {!isMobile && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 3,
            pt: 2.5,
            pb: 0,
          }}
        >
          <Stack spacing={0.5}>
            <Breadcrumbs separator={<NavigateNextIcon sx={{ fontSize: 14 }} />}>
              <Stack direction="row" spacing={0.5} alignItems="center">
                <HomeIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                <Link
                  underline="hover"
                  color="text.secondary"
                  sx={{ fontSize: "0.75rem" }}
                >
                  Home
                </Link>
              </Stack>
              <Typography
                color="text.primary"
                sx={{ fontSize: "0.75rem", fontWeight: 600 }}
              >
                {menuLabels[selectedMenu] || selectedMenu}
              </Typography>
            </Breadcrumbs>
          </Stack>

          <Stack direction="row" spacing={1.5} alignItems="center">
            {/* ← ADD ChangeLang here */}
            <ChangeLang />

            <ThemeToggle
              isDark={isDark}
              toggleColorMode={toggleColorMode}
              theme={theme}
            />
            <Avatar
              onClick={() => history.push("/user?page=profile")}
              sx={{
                width: 34,
                height: 34,
                bgcolor: theme.palette.primary.main,
                fontSize: 13,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              U
            </Avatar>
          </Stack>
        </Box>
      )}
    </>
  );
};

export default UserTopBar;
